import './index.css';
import React from 'react';
import LoadingSvg from '../../../svgs/loading';

const Loading = ({ isLoading }) => {
  return <div className="mcycle-loading" style={{display: isLoading ? 'block': 'none'}}>
    <LoadingSvg />
  </div>
}

export default Loading


// WEBPACK FOOTER //
// ./src/components/common/loading/index.js